import { ArtistLink as GQLItem } from '../../generated/graphql';
import { take } from '../../util';
import { z } from 'zod';

export const artistLinkSchema = z.object({
  id: z.number().optional(),
  url: z.string().url(),
});

export type ArtistLink = z.infer<typeof artistLinkSchema>;

export const fromGql = (item: GQLItem): ArtistLink =>
  take(item, 'id', 'url');

export const fromGqlCollection = (items: GQLItem[]): ArtistLink[] =>
  items.map(item => fromGql(item));
